import NewsroomIndex from './newsroom';
import HoverCursorManager from "../../helpers/hover-cursor-manager";

export default class NewsroomIndexDesktop extends NewsroomIndex {
    constructor(...args) {
        super(...args);

        if( ENV.device == 'desktop' ) {
            this._HoverCursorManager = new HoverCursorManager( {
                container : this.dom.component,
                gallery : {
                    classesName : {
                        items : 'js-news',
                        icons : 'js-icon-download'
                    }
                }
            } );
        }
    }

    _injectData(xhr) {
        super._injectData(xhr);

        if( ENV.device == 'desktop' ) {
            this._HoverCursorManager.retrieveDOM();
        }
    }

    _update( pos ) {
        super._update( pos );

        if( ENV.device == 'desktop' ) {
            this._HoverCursorManager.update( pos );
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/newsroom/newsroom.desktop.js